module.exports = __webpack_public_path__ + "static/media/ice_error.312cba13.svg";